import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=performance&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '业绩评估',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `华美的业绩评估服务从运营管理、市场表现和财务健康三大维度为客户提供全面诊断。在多年实践中，华美发现不少酒店常因管理报表失真、部门协作不畅、成本结构失衡等问题而陷入经营困境。华美通过深度剖析经营数据，为每家酒店量身定制解决方案。`,
        icons: [
            {
                name: '业绩评估',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/9.业绩评估.pdf'),
                path: "四库赋能-酒店资管/业绩评估/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店资管/业绩评估/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/业绩评估/数据赋能'),
                path: "四库赋能-酒店资管/业绩评估/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/业绩评估/全球案例/全球案例（业绩评估）.xlsx'),
                path: "四库赋能-酒店资管/业绩评估/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/业绩评估/预警问题/预警问题（业绩评估）.xlsx'),
                path: "四库赋能-酒店资管/业绩评估/预警问题"
            },
        ]
    }]
}